import { Box, Button, Alert, AlertTitle } from '@mui/material';

interface Props {
    alerts: boolean;
    setAlerts: (value: boolean) => void;
    closeForm: () => void;
    t: any;
}

export const AlertCustom = ({ alerts, setAlerts, closeForm, t }: Props) => {
    return (
        <Box sx={{ top: 0, zIndex: 10, pb: 1 }}>
            {alerts && (
                <Alert
                    variant="filled"
                    severity="warning"
                    sx={{ mt: 2, marginLeft: 3, marginRight: 3 }}
                    action={
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button onClick={() => setAlerts(false)} color="error" size="small" variant="contained" disableElevation>
                                {t('general.alerts.unsaved_changes.buttons.yes')}
                            </Button>

                            <Button onClick={() => closeForm()} style={{ backgroundColor: 'red' }} size="small" variant="contained" disableElevation>
                                {t('general.alerts.unsaved_changes.buttons.no')}
                            </Button>
                        </Box>
                    }
                >
                    <AlertTitle>{t('general.alerts.unsaved_changes.message')}</AlertTitle>
                </Alert>
            )}
        </Box>
    );
};
